class BlipPortalToastTypes {
    static INFO = 'info';

    static SUCCESS = 'success';

    static WARNING = 'warning';

    static DANGER = 'danger';

    static REFRESH = 'refresh';
}

export default BlipPortalToastTypes;
